import { Component, OnDestroy, OnInit, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { Observable } from 'rxjs';
import { ErrorMessageService } from 'src/app/services/error-message.service';
import { MessageModel } from '../../models/message-model';

@Component({
  selector: 'ness-message',
  templateUrl: './message.component.html'
})
export class MessageComponent implements OnInit, OnDestroy, AfterViewChecked {
  message$: Observable<MessageModel>;

  constructor(private errorMessageService: ErrorMessageService, private cdr: ChangeDetectorRef) { }

  ngOnDestroy() {
    this.errorMessageService.clear();
  }

  ngOnInit() {
    this.message$ = this.errorMessageService.message;
  }

  ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }

  public onAlertClose(): void {
    this.errorMessageService.clear();
  }
}
